/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestReminders } from './RequestReminders';
import {
    RequestRemindersFromJSON,
    RequestRemindersFromJSONTyped,
    RequestRemindersToJSON,
    RequestRemindersToJSONTyped,
} from './RequestReminders';
import type { OutreachAttempt } from './OutreachAttempt';
import {
    OutreachAttemptFromJSON,
    OutreachAttemptFromJSONTyped,
    OutreachAttemptToJSON,
    OutreachAttemptToJSONTyped,
} from './OutreachAttempt';

/**
 * 
 * @export
 * @interface ReminderOverview
 */
export interface ReminderOverview {
    /**
     * 
     */
    facility_timezone: string | null;
    /**
     * 
     */
    requests: Array<RequestReminders>;
    /**
     * 
     */
    attempts: Array<OutreachAttempt>;
}

/**
 * Check if a given object implements the ReminderOverview interface.
 */
export function instanceOfReminderOverview(value: object): value is ReminderOverview {
    if (!('facility_timezone' in value) || value['facility_timezone'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    return true;
}

export function ReminderOverviewFromJSON(json: any): ReminderOverview {
    return ReminderOverviewFromJSONTyped(json, false);
}

export function ReminderOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReminderOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_timezone': json['facility_timezone'],
        'requests': ((json['requests'] as Array<any>).map(RequestRemindersFromJSON)),
        'attempts': ((json['attempts'] as Array<any>).map(OutreachAttemptFromJSON)),
    };
}

export function ReminderOverviewToJSON(json: any): ReminderOverview {
    return ReminderOverviewToJSONTyped(json, false);
}

export function ReminderOverviewToJSONTyped(value?: ReminderOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_timezone': value['facility_timezone'],
        'requests': ((value['requests'] as Array<any>).map(RequestRemindersToJSON)),
        'attempts': ((value['attempts'] as Array<any>).map(OutreachAttemptToJSON)),
    };
}

